'use strict';

export class BrandFilter {

    constructor(args) {
        this.field = 'brand';
        this.params = args;
    }

    getQueryString() {
        return this.params.join(':');
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/Services/Search/BrandFilter.js